import React from "react";
import moment from 'moment';

import { StudioManager } from "../../studio-manager";

export class CalendarColumn extends React.Component {
  constructor (props) {
    super(props);

    var slots = [];
    for (var i = this.props.min; i < this.props.max + 1; i++) {
      slots.push({
        index: i,
        title: `${i}:00 - ${i + 1}:00`,
        event: this.slot(i)
      });
    }

    this.state = { slots, activeId: null };
  }

  slot = (hour) => {
    var event = this.props.day.events.find(event => event.hour == hour);
    if (event) return event;
    else return null;
  }

  componentDidMount () {
    StudioManager.instance.on('slots-updated', this.update);
  }

  update = () => {
    var now = moment();
    var activeId = StudioManager.instance.slotA.id;
    if (StudioManager.instance.slotA.start.isAfter(now)) activeId = null;
    this.setState({ activeId });
  }

  render () {
    return (
      <div className="column">
        <div className="column__day">{ this.props.day.day.format('dddd D MMMM') }</div>
        { this.state.slots.map((slot, index) => (
          <div key={`${this.props.day.dayString}-slot-${index}}`} className={`column__slot ${ !slot.event && 'column__slot--empty' } ${ (slot.event && slot.event.id === this.state.activeId) && 'column__slot--active' }`}>
            <div className="column__slot__time">{ slot.title }</div>
            <div className="column__slot__artist">{ slot.event ? slot.event.summary : '' }</div>
          </div>
        )) }
      </div>
    )
  }
}
